import React from 'react';
import { SearchX } from 'lucide-react';
import { Link } from '../router';
import { ROUTES } from '../routes.js';

const NotFound: React.FC = () => {
  const tools = ROUTES.filter((r) => r.heading);

  return (
    <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-200 max-w-2xl mx-auto text-center animate-fade-in">
      <SearchX size={40} className="mx-auto text-slate-400" />
      <h1 className="text-2xl font-bold text-slate-900 mt-4">Page not found</h1>
      <p className="text-slate-600 mt-2">
        That URL doesn't match any tool on EpochTimer. Try one of these instead:
      </p>
      <div className="flex flex-wrap justify-center gap-2 mt-6">
        {tools.map((tool) => (
          <Link
            key={tool.path}
            href={tool.path}
            className="px-3 py-1.5 rounded-md bg-sky-50 text-sky-700 hover:bg-sky-100 transition-colors text-sm font-medium"
          >
            {tool.heading}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NotFound;
